import VenueFeedbackForm from "@/components/feedback/venue-feedback-form";
import { useLocalSearchParams } from "expo-router";
import Drawer from "expo-router/drawer";
import { Text, View, ActivityIndicator } from "react-native";
import { KeyboardAwareScrollView, KeyboardToolbar } from "react-native-keyboard-controller";
import { trpc } from "@/trpc/react";
import { useMemo } from "react";

export default function VenueFeedbackPage() {
  const { id } = useLocalSearchParams();
  const jobDateId = Number(id);

  const { data: jobDataResult, isLoading } = trpc.jobDateListRouter.getById.useQuery(jobDateId);
  const jobData = useMemo(() => jobDataResult?.data, [jobDataResult?.data]);

  const { data: jobVenueResult, isLoading: venueLoading } = trpc.venueFeedback.getJobVenueByJobDate.useQuery(jobDateId);
  const jobVenue = useMemo(() => jobVenueResult, [jobVenueResult]);

  if (isLoading || venueLoading) {
    return (
      <>
        <Drawer.Screen
          options={{
            title: 'Venue Feedback',
          }}
        />
        <View className="flex-1 justify-center items-center bg-background">
          <ActivityIndicator size="large" color="#888888" />
        </View>
      </>
    );
  }

  if (!jobData || !jobVenue) {
    return (
      <>
        <Drawer.Screen
          options={{
            title: 'Venue Feedback',
          }}
        />
        <View className="flex-1 justify-center items-center bg-background p-4">
          <Text className="text-xl text-foreground font-bold text-center">
            No venue information available for this job
          </Text>
        </View>
      </>
    );
  }

  return (
    <>
      <Drawer.Screen
        options={{
          title: 'Venue Feedback',
        }}
      />
      <KeyboardAwareScrollView
        bottomOffset={62}
        className="flex-1 bg-background p-4"
        contentContainerStyle={{
          gap: 20,
          paddingTop: 40,
        }}
      >
        <Text className="text-xl text-foreground font-extrabold tracking-tight self-start">
          Provide feedback for {jobVenue.name || 'venue'}
        </Text>
        <VenueFeedbackForm
          jobVenueId={jobVenue.id}
          jobDateId={jobDateId}
        />
      </KeyboardAwareScrollView>
      <KeyboardToolbar />
    </>
  );
}
